import { ReactNode, useCallback, useEffect, useState } from 'react';
import { ModalCore } from './ModalCore';

export const useModalProps = (openOnMount?: boolean): ModalProps => {
  const [opened, setOpened] = useState(openOnMount || false);

  const open = useCallback(() => setOpened(true), []);

  const close = useCallback(() => setOpened(false), []);

  useEffect(() => {
    if (openOnMount) {
      setOpened(openOnMount);
    }
  }, [setOpened, openOnMount]);

  return { opened, open, close };
};

export type ModalContentProps = {
  onClose: () => void;
};

export type ModalContent = (props: ModalContentProps) => ReactNode;

export type ModalTriggerProps = {
  onClick: () => void;
};

export type ModalTrigger = (props: ModalTriggerProps) => ReactNode;

export type ModalProps = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

type Props = {
  content: ModalContent;
  trigger: ModalTrigger;
  className?: string;
};

export const Modal = ({ content, trigger, className }: Props) => {
  const { opened, open, close } = useModalProps();

  return (
    <>
      <ModalCore className={className} opened={opened} close={close}>
        {content({ onClose: close })}
      </ModalCore>
      {trigger({ onClick: open })}
    </>
  );
};
